import React, { useMemo } from 'react';
import BasicModal from '../components/shared/BasicModal/BasicModal';
import IconLabel from '../components/shared/IconLabel/IconLabel';
import ModalTitle from '../components/shared/ModalTitle/ModalTitle';
import { useFetchLocationsAndLanguagesQuery } from '../trackedWebsites/service';
import { useUpdateWebsiteIndexEntrySettingsMutation } from '../deepAnalysis/websiteIndexEntry/service';
import ChangeLocationAndLanguageForm from './ChangeLocationAndLanguageForm';
import { getLanguageFromCode } from '../trackedWebsites/utils';
import { useChangeKeywordsLocationAndLanguageMutation } from './service';


type Props = {
    websiteGuid: string;
    domain: string;
    locationName: string;
    languageCode: string;
};


export default function ChangeLocationAndLanguage({ websiteGuid, domain, locationName, languageCode }: Props) {
    const { data: locationsAndLanguages, isLoading: isLoadingLocationsAndLanguages } = useFetchLocationsAndLanguagesQuery();

    //const selectedWebsiteLocation = selectedWebsite.settings?.location_name || 'United States';
    const selectedWebsiteLanguage = useMemo(
        () => (locationsAndLanguages ? getLanguageFromCode(locationName, languageCode, locationsAndLanguages) : ''),
        [locationsAndLanguages, locationName, languageCode]
    );

    const [changeKeywordsLocationAndLanguage, { isLoading: isChangingLocationAndLanguageForKeywords }] = useChangeKeywordsLocationAndLanguageMutation();
    const [updateWebsiteIndexEntrySettings, { isLoading: isChangingLocationAndLanguageForWebsite }] = useUpdateWebsiteIndexEntrySettingsMutation();
    const isChangingLocationAndLanguage = isChangingLocationAndLanguageForKeywords || isChangingLocationAndLanguageForWebsite;

    const handleLocationChange = async (newLocation: string, newLanguageCode: string) => {
        try {
            await changeKeywordsLocationAndLanguage({ domain: domain, locationName: newLocation, languageCode: newLanguageCode }).unwrap();
            await updateWebsiteIndexEntrySettings({ guid: websiteGuid, location_name: newLocation, language_code: newLanguageCode }).unwrap();
        } catch (error) { }
    };

    return (
        <BasicModal
            openLabel={
                <IconLabel
                    icon="global"
                    label={isLoadingLocationsAndLanguages ? 'Loading...' : `${locationName} (${selectedWebsiteLanguage})`}
                />
            }
            modalTitle={<ModalTitle title="Location & Language" meta={domain} />}
            isPerformingAction={isChangingLocationAndLanguage}
            isButtonDisabled={isLoadingLocationsAndLanguages}
        >
            <ChangeLocationAndLanguageForm
                customClassName={'change-tracked-keywords-form'}
                initialLocation={locationName}
                initialLanguageCode={languageCode}
                onSubmit={handleLocationChange}
                isChangingLanguageAndLocation={isChangingLocationAndLanguage}
            />
        </BasicModal>
    );
}
